import { render, staticRenderFns } from "./FEpochDetail.vue?vue&type=template&id=15a97c2b&scoped=true&"
import script from "./FEpochDetail.vue?vue&type=script&lang=js&"
export * from "./FEpochDetail.vue?vue&type=script&lang=js&"
import style0 from "./FEpochDetail.vue?vue&type=style&index=0&id=15a97c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a97c2b",
  null
  
)

export default component.exports